import { UPDATE_CURRENT_SERVING } from "./actionTypes";

export default (payload) => ({
  type: UPDATE_CURRENT_SERVING,
  payload,
});